/* ============================================================
   ERMITUS — comportements du thème
   Conforme au Design Specification, Phase C.
   JavaScript natif uniquement, aucune dépendance externe.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.ErmitusConfig || {};
  var T = CFG.textes || {};
  var mouvementReduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches || CFG.animations === false;

  /* ---------- format monétaire Shopify ---------- */
  function formaterArgent(centimes, format) {
    format = format || CFG.formatArgent || '{{amount}}';
    var valeur = (centimes || 0) / 100;

    function avecSeparateurs(nombre, decimales, sepDecimal, sepMillier) {
      var parts = nombre.toFixed(decimales).split('.');
      var entier = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sepMillier);
      return parts[1] ? entier + sepDecimal + parts[1] : entier;
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, nom) {
      switch (nom) {
        case 'amount': return avecSeparateurs(valeur, 2, '.', ',');
        case 'amount_no_decimals': return avecSeparateurs(valeur, 0, '.', ',');
        case 'amount_with_comma_separator': return avecSeparateurs(valeur, 2, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return avecSeparateurs(valeur, 0, ',', '.');
        case 'amount_with_space_separator': return avecSeparateurs(valeur, 2, ',', ' ');
        case 'amount_no_decimals_with_space_separator': return avecSeparateurs(valeur, 0, ',', ' ');
        case 'amount_with_apostrophe_separator': return avecSeparateurs(valeur, 2, '.', "'");
        default: return avecSeparateurs(valeur, 2, '.', ',');
      }
    });
  }

  function echapper(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  /* ---------- révélations au défilement ---------- */
  function initRevelations() {
    var cibles = document.querySelectorAll('.rev');
    if (!cibles.length) return;
    if (mouvementReduit || !('IntersectionObserver' in window)) {
      cibles.forEach(function (el) { el.classList.add('est-vu'); });
      return;
    }
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('est-vu'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
    cibles.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- entête au défilement + parallaxe ---------- */
  function initDefilement() {
    var entete = document.querySelector('[data-entete]');
    var plans = document.querySelectorAll('[data-parallaxe]');
    var enAttente = false;

    function appliquer() {
      var y = window.scrollY;
      if (entete && !entete.classList.contains('est-clair-fixe')) {
        entete.classList.toggle('est-dur', y > 70);
      }
      if (!mouvementReduit && CFG.parallaxe !== false) {
        plans.forEach(function (plan) {
          var coef = parseFloat(plan.getAttribute('data-parallaxe')) || 0.14;
          var hote = plan.parentElement;
          var r = hote.getBoundingClientRect();
          if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
          var centre = r.top + r.height / 2 - window.innerHeight / 2;
          plan.style.transform = 'translate3d(0,' + (-centre * coef).toFixed(2) + 'px,0)';
        });
      }
      enAttente = false;
    }

    window.addEventListener('scroll', function () {
      if (!enAttente) { enAttente = true; requestAnimationFrame(appliquer); }
    }, { passive: true });
    window.addEventListener('resize', appliquer, { passive: true });
    appliquer();
  }

  /* ---------- piège à focus ---------- */
  function piegerFocus(conteneur) {
    var selecteur = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';
    function gerer(e) {
      if (e.key !== 'Tab') return;
      var elements = Array.prototype.filter.call(
        conteneur.querySelectorAll(selecteur),
        function (el) { return el.offsetParent !== null; }
      );
      if (!elements.length) return;
      var premier = elements[0], dernier = elements[elements.length - 1];
      if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    }
    conteneur.addEventListener('keydown', gerer);
    return function () { conteneur.removeEventListener('keydown', gerer); };
  }

  /* ---------- menu mobile ---------- */
  function initMenu() {
    var bascule = document.querySelector('[data-ouvrir-menu]');
    var menu = document.getElementById('menu-mobile');
    if (!bascule || !menu) return;
    var liberer = null;

    function ouvrir(etat) {
      menu.classList.toggle('est-ouvert', etat);
      menu.setAttribute('aria-hidden', etat ? 'false' : 'true');
      bascule.setAttribute('aria-expanded', etat ? 'true' : 'false');
      document.body.style.overflow = etat ? 'hidden' : '';
      if (etat) {
        liberer = piegerFocus(menu);
        var p = menu.querySelector('a'); if (p) p.focus();
      } else {
        if (liberer) { liberer(); liberer = null; }
        bascule.focus();
      }
    }

    bascule.addEventListener('click', function () {
      ouvrir(!menu.classList.contains('est-ouvert'));
    });
    menu.querySelectorAll('[data-fermer-menu], a').forEach(function (el) {
      el.addEventListener('click', function () { ouvrir(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('est-ouvert')) ouvrir(false);
    });
  }

  /* ---------- sélecteur de variantes ---------- */
  function initVariantes() {
    var racine = document.querySelector('[data-produit]');
    if (!racine) return;
    var balise = document.querySelector('[data-variantes]');
    if (!balise) return;

    var variantes;
    try { variantes = JSON.parse(balise.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var selecteurs = racine.querySelectorAll('[data-selecteur-option]');
    var champId = racine.querySelector('[data-champ-variante]');
    var champPrix = racine.querySelector('[data-prix]');
    var champPrixCompare = racine.querySelector('[data-prix-compare]');
    var bouton = racine.querySelector('[data-bouton-ajout]');
    var galerie = racine.querySelector('[data-galerie]');
    if (!selecteurs.length) return;

    function trouver() {
      var choix = Array.prototype.map.call(selecteurs, function (s) { return s.value; });
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i], ok = true;
        for (var j = 0; j < choix.length; j++) {
          if (v.options[j] !== choix[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function appliquer() {
      var v = trouver();

      if (!v) {
        if (champId) champId.value = '';
        if (bouton) { bouton.disabled = true; bouton.textContent = T.indisponible || '—'; }
        if (champPrix) champPrix.textContent = T.indisponible || '—';
        if (champPrixCompare) { champPrixCompare.hidden = true; champPrixCompare.textContent = ''; }
        return;
      }

      if (champId) champId.value = v.id;
      if (champPrix) {
        champPrix.textContent = v.available ? v.prix_formate : (T.indisponible || '—');
        champPrix.classList.toggle('prix__solde', Boolean(v.available && v.en_solde));
      }
      if (champPrixCompare) {
        champPrixCompare.hidden = !(v.available && v.en_solde);
        champPrixCompare.textContent = v.available && v.en_solde ? (v.prix_compare_formate || '') : '';
      }
      if (bouton) {
        bouton.disabled = !v.available;
        bouton.textContent = v.available ? (T.ajouter || 'Ajouter au panier') : (T.indisponible || '—');
      }

      /* URL de variante, sans rechargement */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      /* média associé à la variante */
      if (galerie && v.media_id) {
        var cible = galerie.querySelector('[data-media-id="' + v.media_id + '"]');
        if (cible) galerie.prepend(cible);
      }
    }

    selecteurs.forEach(function (s) { s.addEventListener('change', appliquer); });
    racine.querySelectorAll('[data-option-valeur]').forEach(function (b) {
      b.addEventListener('click', function () {
        var index = parseInt(b.getAttribute('data-option-index'), 10);
        var selecteur = selecteurs[index];
        if (!selecteur) return;
        selecteur.value = b.getAttribute('data-option-valeur');
        racine.querySelectorAll('[data-option-index="' + index + '"]').forEach(function (autre) {
          var actif = autre === b;
          autre.classList.toggle('est-active', actif);
          autre.setAttribute('aria-pressed', actif ? 'true' : 'false');
        });
        selecteur.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    appliquer();
  }

  /* ---------- agrandissement des médias produit ---------- */
  function initModaleMedia() {
    if (CFG.agrandissementMedia === false) return;
    var modale = document.getElementById('modale-media');
    if (!modale) return;
    var image = modale.querySelector('[data-media-agrandie]');
    var dernierFocus = null;
    var liberer = null;

    function fermer() {
      if (modale.getAttribute('aria-hidden') !== 'false') return;
      modale.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (liberer) { liberer(); liberer = null; }
      if (dernierFocus) dernierFocus.focus();
    }

    function ouvrir(declencheur) {
      var src = declencheur.getAttribute('data-src');
      if (!src || !image) return;
      dernierFocus = declencheur;
      image.src = src;
      image.alt = declencheur.getAttribute('data-alt') || '';
      modale.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      liberer = piegerFocus(modale);
      var boutonFermer = modale.querySelector('.modale-media__fermer');
      if (boutonFermer) boutonFermer.focus();
    }

    document.addEventListener('click', function (e) {
      var declencheur = e.target.closest('[data-ouvrir-media]');
      if (!declencheur) return;
      e.preventDefault();
      ouvrir(declencheur);
    });
    modale.querySelectorAll('[data-fermer-media]').forEach(function (el) {
      el.addEventListener('click', fermer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') fermer();
    });
  }

  /* ---------- tiroir panier ---------- */
  function initPanier() {
    var tiroir = document.getElementById('tiroir-panier');
    if (!tiroir) return;
    if (CFG.modePanier !== 'tiroir') return;
    var corps = tiroir.querySelector('[data-contenu-panier]');
    var dernierFocus = null;
    var liberer = null;

    function basculer(etat) {
      tiroir.setAttribute('aria-hidden', etat ? 'false' : 'true');
      document.body.style.overflow = etat ? 'hidden' : '';
      if (etat) {
        dernierFocus = document.activeElement;
        liberer = piegerFocus(tiroir);
        var f = tiroir.querySelector('.tiroir-fermer');
        if (f) f.focus();
      } else {
        if (liberer) { liberer(); liberer = null; }
        if (dernierFocus) dernierFocus.focus();
      }
    }

    function rendre(panier) {
      if (!corps) return;
      if (!panier || panier.item_count === 0) {
        var modeleVide = document.getElementById('modele-panier-vide');
        corps.innerHTML = modeleVide ? modeleVide.innerHTML : '<p class="vide">' + echapper(T.panierVide || '') + '</p>';
        return;
      }
      var html = '';
      panier.items.forEach(function (it, i) {
        var img = '';
        if (CFG.panierImages !== false) {
          img = it.image
            ? '<div class="media"><img src="' + echapper(it.image) + '" alt="' + echapper(it.product_title) + '" loading="lazy"></div>'
            : '<div class="media media--vide media--clair"></div>';
        }
        html +=
          '<div class="ligne-panier' + (CFG.panierImages === false ? ' ligne-panier--sans-image' : '') + '" data-ligne="' + (i + 1) + '">' + img +
            '<div>' +
              '<a class="carte__nom" style="margin-top:0;font-size:18px" href="' + echapper(it.url) + '">' +
                echapper(it.product_title) + '</a>' +
              (CFG.panierFournisseur === true && it.vendor ? '<div class="produit__type panier-fournisseur">' + echapper(it.vendor) + '</div>' : '') +
              (it.variant_title ? '<div class="produit__type">' + echapper(it.variant_title) + '</div>' : '') +
              (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan ? '<div class="produit__type">' + echapper(it.selling_plan_allocation.selling_plan.name) + '</div>' : '') +
              '<div class="prix" style="margin-top:8px">' + formaterArgent(it.final_line_price) + '</div>' +
              '<div class="ligne-actions">' +
                '<button type="button" class="qte-bouton" data-qte="' + (i + 1) + '" data-valeur="' + (it.quantity - 1) + '" aria-label="' + echapper(T.diminuer || '-') + '">&minus;</button>' +
                '<span class="qte-valeur">' + it.quantity + '</span>' +
                '<button type="button" class="qte-bouton" data-qte="' + (i + 1) + '" data-valeur="' + (it.quantity + 1) + '" aria-label="' + echapper(T.augmenter || '+') + '">+</button>' +
                '<button type="button" class="fil qte-retirer" data-qte="' + (i + 1) + '" data-valeur="0">' + echapper(T.retirer || '') + '</button>' +
              '</div>' +
            '</div>' +
          '</div>';
      });
      if (CFG.panierNote === true) {
        html += '<div class="panier-note-bloc">' +
          '<label class="sur-titre" for="note-panier-tiroir">' + echapper(T.notePanier || '') + '</label>' +
          '<textarea id="note-panier-tiroir" data-note-panier rows="3" placeholder="' + echapper(T.notePanierPlaceholder || '') + '">' + echapper(panier.note || '') + '</textarea>' +
        '</div>';
      }
      html +=
        '<div class="panier-total"><span>' + echapper(T.total || '') + '</span>' +
        '<span>' + formaterArgent(panier.total_price) + '</span></div>' +
        '<a class="bouton bouton--pleine" href="' + (CFG.urlCommande || '/checkout') + '">' +
        echapper(T.commander || '') + '</a>' +
        (CFG.panierContinuer !== false
          ? '<a class="fil panier-continuer" href="' + echapper(CFG.urlBoutique || '/') + '">' + echapper(CFG.texteContinuer || '') + '</a>'
          : '');
      corps.innerHTML = html;
      brancherQuantites();
      brancherNote();
    }

    function afficherErreur(message) {
      if (!corps) return;
      corps.innerHTML = '<p class="vide message-erreur">' + echapper(message) + '</p>';
    }

    function charger() {
      return fetch(CFG.urlPanier || '/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('cart');
          return r.json();
        })
        .then(function (p) { rendre(p); majCompteur(p.item_count); })
        .catch(function () { afficherErreur(T.erreurPanier || ''); });
    }

    function changerQuantite(ligne, quantite) {
      return fetch(CFG.urlModifier || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: ligne, quantity: quantite })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('change');
          return r.json();
        })
        .then(function (p) { rendre(p); majCompteur(p.item_count); })
        .catch(function () { afficherErreur(T.erreurPanier || ''); });
    }

    function enregistrerNote(note) {
      return fetch(CFG.urlMiseAJour || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: note })
      }).then(function (r) {
        if (!r.ok) throw new Error('note');
        return r.json();
      }).catch(function () {
        afficherErreur(T.erreurPanier || '');
      });
    }

    function brancherNote() {
      var champ = corps.querySelector('[data-note-panier]');
      if (!champ) return;
      var valeurInitiale = champ.value;
      var timerNote = null;
      champ.addEventListener('input', function () {
        clearTimeout(timerNote);
        timerNote = setTimeout(function () {
          if (champ.value === valeurInitiale) return;
          valeurInitiale = champ.value;
          enregistrerNote(champ.value);
        }, 450);
      });
      champ.addEventListener('blur', function () {
        clearTimeout(timerNote);
        if (champ.value === valeurInitiale) return;
        valeurInitiale = champ.value;
        enregistrerNote(champ.value);
      });
    }

    function brancherQuantites() {
      corps.querySelectorAll('[data-qte]').forEach(function (b) {
        b.addEventListener('click', function () {
          var ligne = parseInt(b.getAttribute('data-qte'), 10);
          var val = parseInt(b.getAttribute('data-valeur'), 10);
          if (isNaN(ligne) || isNaN(val) || val < 0) return;
          changerQuantite(ligne, val);
        });
      });
    }

    function majCompteur(nombre) {
      document.querySelectorAll('[data-compteur-panier]').forEach(function (el) {
        el.textContent = nombre > 0 ? '(' + nombre + ')' : '';
      });
    }

    document.querySelectorAll('[data-ouvrir-panier]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        basculer(true);
        charger();
      });
    });
    tiroir.querySelectorAll('[data-fermer-tiroir]').forEach(function (el) {
      el.addEventListener('click', function () { basculer(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && tiroir.getAttribute('aria-hidden') === 'false') basculer(false);
    });

    /* ajout au panier : le tiroir ne s'ouvre qu'en cas de succès */
    document.querySelectorAll('[data-form-ajout]').forEach(function (form) {
      var zoneErreur = form.querySelector('[data-erreur-produit]');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var bouton = form.querySelector('[type="submit"]');
        if (zoneErreur) { zoneErreur.hidden = true; zoneErreur.textContent = ''; }
        if (bouton) bouton.disabled = true;

        fetch(CFG.urlAjout || '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) {
            return r.json().then(function (donnees) {
              if (!r.ok) throw new Error(donnees.description || donnees.message || 'ajout');
              return donnees;
            });
          })
          .then(function () {
            if (CFG.ouvrirApresAjout !== false) basculer(true);
            return charger();
          })
          .catch(function (err) {
            if (zoneErreur) {
              zoneErreur.textContent = err.message || (T.erreurAjout || '');
              zoneErreur.hidden = false;
            }
          })
          .then(function () { if (bouton) bouton.disabled = false; });
      });
    });
  }


  /* ---------- recherche prédictive ---------- */
  function initRecherchePredictive() {
    document.querySelectorAll('[data-recherche-predictive]').forEach(function (bloc) {
      var champ = bloc.querySelector('[data-champ-predictif]');
      var zone = bloc.querySelector('[data-zone-predictive]');
      var endpoint = bloc.getAttribute('data-url-predictive');
      if (!champ || !zone || !endpoint) return;
      var timer = null;
      var controleur = null;

      function fermer() {
        zone.hidden = true;
        zone.innerHTML = '';
        champ.setAttribute('aria-expanded', 'false');
      }

      function chercher() {
        var q = champ.value.trim();
        if (q.length < 2) { fermer(); return; }
        if (controleur) controleur.abort();
        controleur = new AbortController();
        var sep = endpoint.indexOf('?') === -1 ? '?' : '&';
        var url = endpoint + sep + 'q=' + encodeURIComponent(q) + '&section_id=recherche-predictive&resources[type]=product&resources[limit]=6';
        fetch(url, { signal: controleur.signal, headers: { 'Accept': 'text/html' } })
          .then(function (r) { if (!r.ok) throw new Error('search'); return r.text(); })
          .then(function (html) {
            zone.innerHTML = html;
            zone.hidden = html.trim() === '';
            champ.setAttribute('aria-expanded', zone.hidden ? 'false' : 'true');
          })
          .catch(function (err) { if (err.name !== 'AbortError') fermer(); });
      }

      champ.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(chercher, 180);
      });
      champ.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') fermer();
      });
      document.addEventListener('click', function (e) {
        if (!bloc.contains(e.target)) fermer();
      });
    });
  }

  function init() {
    initRevelations();
    initDefilement();
    initMenu();
    initVariantes();
    initModaleMedia();
    initPanier();
    initRecherchePredictive();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
